

function Error() {

  return (
    <div className="header page-header-error section-padding valign">
      <div className="container">
        <div className="text-center">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="img px-40">
                <img src="/light/assets/imgs/404.png" alt="img" loading='lazy' width="100%" height="100%"/>
              </div>
              <div className="text mt-40">
                <h2 className="mb-10">Page not found</h2>
                <p>Sorry, but the page you are looking for does not exist.</p>
                <a
                  href="/"
                  className="butn butn-md butn-bgx main-colorbg text-dark radius-30 mt-30"
                >
                  <span style={{ color: 'white'}} className="text">Back to Home</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Error;
